import React from "react";

/** Full-screen opening curtain: names, date and an "Ingresar" gate that starts the music. */
export function CoverVeil({ names, eyebrow, date, image, cta = "Ingresar", onEnter, open = false, style }) {
  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: "var(--z-veil)",
        display: "grid", placeItems: "center",
        background: "var(--bg-contrast)",
        opacity: open ? 0 : 1,
        visibility: open ? "hidden" : "visible",
        transition: "opacity var(--dur-veil) var(--ease-entrance), visibility 0s linear " + (open ? "var(--dur-veil)" : "0s"),
        ...style,
      }}
    >
      {image && (
        <img src={image} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: 0.55 }} />
      )}
      <div style={{ position: "absolute", inset: 0, background: "var(--scrim-full)" }} />
      <div style={{ position: "relative", textAlign: "center", padding: "var(--sp-7)", display: "grid", gap: "var(--sp-5)", justifyItems: "center", animation: "ds-rise var(--dur-slow) var(--ease-entrance) both" }}>
        {eyebrow && (
          <p style={{ margin: 0, fontFamily: "var(--font-caps)", fontSize: "var(--fs-eyebrow)", letterSpacing: "var(--ls-widest)", textTransform: "uppercase", color: "var(--fg-on-contrast)", opacity: 0.72 }}>{eyebrow}</p>
        )}
        <h1 style={{ margin: 0, fontFamily: "var(--font-flourish, var(--font-script))", fontWeight: 400, fontSize: "var(--fs-hero)", lineHeight: 1.02, letterSpacing: "var(--ls-hero)", color: "var(--fg-on-contrast)" }}>{names}</h1>
        <div style={{ width: 56, height: 1, background: "var(--fg-on-contrast)", opacity: 0.4 }} />
        {date && (
          <p style={{ margin: 0, fontFamily: "var(--font-caps)", fontSize: "var(--fs-caption)", letterSpacing: "var(--ls-wider)", textTransform: "uppercase", color: "var(--fg-on-contrast)", opacity: 0.88 }}>{date}</p>
        )}
        <button
          type="button"
          onClick={onEnter}
          style={{
            marginTop: "var(--sp-4)", minHeight: 46, padding: "14px 40px",
            border: "var(--border-hair) solid var(--fg-on-contrast)", color: "var(--fg-on-contrast)",
            fontFamily: "var(--font-caps)", fontSize: "var(--fs-eyebrow)", letterSpacing: "var(--ls-wider)", textTransform: "uppercase",
            background: "transparent", transition: "background var(--dur-fast) var(--ease-standard)",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(127,127,127,0.22)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          {cta}
        </button>
      </div>
    </div>
  );
}
